import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import { GenerateIndiceReajusteListaColumns } from "./columns"
import { IndiceReajuste } from "../../../domain/models/indice_reajuste"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { useFinanceiroReajustesListaViewModel } from "../../viewModels/financeiro_reajustes_lista_view_model"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"


export const FinanceiroReajustesLista = () => {

    const viewModel = useFinanceiroReajustesListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateIndiceReajusteListaColumns({
            onActionEdit: viewModel.handleEditIndiceReajuste,
            onActionDelete: viewModel.handleIndiceReajusteDeleteOpenState,

        });
    }, [
        viewModel.handleEditIndiceReajuste,
        viewModel.handleIndiceReajusteDeleteOpenState
    ]);

    return (
        <>s
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewIndiceReajuste()}>
                                    Novo Índice Reajuste
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col md:p-4 px-5 pt-2">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Typography className="text-primary-green">
                        Índices de Reajustes
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Índices de Reajustes</h1>
                        <p>Pesquisar </p>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>


                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                ddlIndiceReajuste={viewModel.ddlIndiceReajuste}
                                selectedIdsIndiceReajuste={viewModel.filters.idsIndiceReajuste ?? []}
                                handleCodigoChange={viewModel.handleCodigoChange}
                                onClearFilters={viewModel.handleClearFilters}
                                handleIdsindiceReajusteChange={viewModel.handleIdsindiceReajusteChange}

                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="indice_reajuste_lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: IndiceReajuste) => row.idIndiceReajuste}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.indiceReajusteLista}
                                    rowCount={viewModel.indiceReajusteLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idIndiceReajuste'],
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>


                        </>
                    )
                }

            </div >

            <DeleteDialog
                open={viewModel.openDeleteModal}
                onClose={() => viewModel.handleIndiceReajusteDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarIndiceReajuste}
            />

        </>
    )
}
